<ui-popup-layout *ngIf="description && icon">
  <ui-popup-body>
    <div #container class="tw-mt-2">
      <div class="tw-flex tw-items-center tw-gap-2">
        <img class="tw-rounded-md tw-w-6 tw-h-6 tw-text-xl" [src]="icon"/>
        <h2 class="tw-font-medium tw-text-2xl">{{ title }}</h2>
      </div>
      <p class="tw-pt-2 tw-pb-3 tw-text-base-text/60">{{ description }}</p>
    </div>
  </ui-popup-body>
</ui-popup-layout>
